<template>
	<!-- <div :class="{ 'with-background': background }" :style="'background-image:url(' + background + ')'"> -->
	<div :class="{ 'with-background': background }">
		<Navbar :navFixed="navFixed" :transparent="transparent" :invert="invert" :withImage="withImage" :hideCart="hideCart" :hideMenu="hideMenu"></Navbar>
		<div class="background" v-if="background" :style="'background-image:url(' + background + ')'"></div>

		<Loader :show="loading"></Loader>

		<div class="" v-if="!loading" sticky-container>
			<slot></slot>
		</div>

		<Footer v-if="!hideFooter" :hideFooterDecoration="hideFooterDecoration" />
	</div>
</template>
<script>
import Navbar from '@/components/Navbar'
import Loader from '@/components/Loader'
import Footer from '@/components/Footer'

export default {
	name: 'Layout',
	props: ['loading', 'pageTitle', 'navFixed', 'background', 'transparent', 'withImage', 'invert', 'hideCart', 'hideMenu', 'hideFooter','hideFooterDecoration'],
	components: {
		Navbar,
		Loader,
		Footer,
	},
}
</script>

<style scoped>
.main-container {
	padding: 18px;
}
.with-background {
	background-size: contain;
}

@media (max-width: 768px) {
	.with-background {
		background: none !important;
	}
}
@media (max-width: 991px) {
	.main {
		width: 100%;
		margin-left: 0px;
	}
}

.background {
	width: 100%;
	padding-bottom: 280px;
	background-size: cover;
	background-position: center center;
	margin-bottom: -64px;
}
</style>
